import { fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import Color from "../../../assets/styles/colors";

const fadeInAnimation = keyframes`${fadeIn}`;

export const Container = styled.div`
  animation: 1s ${fadeInAnimation};
`;

export const Div = styled.div``;

export const TransactionTitle = styled.div`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackSeven
      : Color.textColorBlackSix};
`;

export const TransactionDate = styled.div`
  color: ${Color.textColorBlackTow};
`;

export const TransactionMsg = styled.div`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackOne
      : Color.textColorBlackFor};
`;

export const TransactionPrice = styled.div`
  color: ${(props) =>
    props.theme?.isDarkTheme
      ? Color.textColorBlackSeven
      : Color.textColorBlackFor};
`;
